import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { PaymentMethod, RidangoReduxAction } from '@ridango/core';

import { PaymentMethodsActions } from './payment-methods.actions';
import { PAYMENT_METHODS_STATE_KEY, PaymentMethodsPartialStoreState } from './payment-methods.reducer';
import * as PaymentMethodsSelectors from './payment-methods.selectors';
import { CartStatus } from '../../../lib/purchase/purchase.model';
import { Observable } from 'rxjs';

@Injectable()
export class PaymentMethodsFacade {
    allPaymentMethods$ = this.store.select(PaymentMethodsSelectors.getAllPaymentMethods);
    selectedPaymentMethod$ = this.store.select(PaymentMethodsSelectors.getSelectedPaymentMethod);
    loading$ = this.store.select(PaymentMethodsSelectors.getPaymentMethodsLoading);
    paymentError$ = this.store.select(PaymentMethodsSelectors.getPaymentError);
    adyenSession$ = this.store.select(PaymentMethodsSelectors.getAdyenSession);
    private cartRedirectUrl$ = this.store.select(PaymentMethodsSelectors.getCartRedirectUrl);

    constructor(
        private store: NgRedux<PaymentMethodsPartialStoreState>,
        private actions: PaymentMethodsActions
    ) {}

    dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }

    fetchAllMethods() {
        this.dispatch(this.actions.fetchStart());
    }

    fetchAllMethodsWithEpic(cart) {
        this.dispatch(this.actions.fetchStartWithEpic(cart));
    }

    setSelectedMethod(method: PaymentMethod) {
        this.dispatch(this.actions.setSelected(method));
    }

    fetchAdyenSession(shoppingCartId: number, lang: string, returnUrl: string) {
        this.dispatch(this.actions.fetchAdyenSession(shoppingCartId, lang, returnUrl));
    }

    fetchPaymentStatus(token: string) {
        this.dispatch(this.actions.fetchAdyenPaymentStatus(token));
    }

    setCartStatus(value: CartStatus) {
        this.dispatch(this.actions.setCartStatus(value));
    }

    setCartRedirectUrl(value: string) {
        this.dispatch(this.actions.setCartRedirectUrl(value));
    }

    getCartStatus(): CartStatus {
        return this.store.getState()[PAYMENT_METHODS_STATE_KEY].cartStatus;
    }

    getCartRedirectUrl(): Observable<string> {
        return this.cartRedirectUrl$;
    }
}
